module.exports = __webpack_public_path__ + "static/SE_Logo-856ba6abe0107e3833c6e8a79706d6e5.png";